import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalDataService } from '../../../services/global-data.service';

@Injectable()
export class ExpenseService {

constructor(
            private http: HttpClient, 
            private global: GlobalDataService
           ) { } 


   getExpense() {
        return this.http.get(this.global.httpUrl+"expenses");
   }

   getExpenseById(id: any) {
        return this.http.get(this.global.httpUrl+"expenses/"+id);
   } 

   createExpense(data: any){
        return this.http.post(this.global.httpUrl+"expenses", data); 
   }

   updateExpense(data: any,id: any){
        return this.http.put(this.global.httpUrl+"expenses/"+id, data); 
   } 

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/expenses/expense.service.ts